export default "__VITE_ASSET__9e71988d__"